import React from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import { Link } from 'gatsby';
import { CookiesProvider } from "react-cookie";

const GlobalStyles = createGlobalStyle`
  .formDesign {

    label {
      margin: 20px 0;
      display: block;

      input {
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        border-radius: 3px !important;
        display: block;
        padding: 8px 10px;
        padding-bottom: 7px;
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #000000;
        width: 260px;

        &:focus {
          border: 1px solid #979797;
        }
      }

      span {
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #A5A5A5;
        margin-bottom: 5px;
        display: block;
      }

      .err {
        font-size: 14px;
        margin-top: 10px;
        color: #EA6A6A;
        margin-bottom: 0px;
      }
    }

    .errorLabel {

      span {
        color: #EA6A6A;
      }
      
      input {
        border-color: #EA6A6A;

        &:focus {
          border: 1px solid #A73030;
        }
      }
    }

    .submitButton {
      width: 170px;
      border: none;
      background: #F2F3F5;
      border-radius: 5px;
      font-family: Visuelt-Medium;
      font-size: 16px;
      color: #0B1C33;
      text-align: center;
      padding-top: 14px;
      padding-bottom: 13px;
      cursor: pointer;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 34px;
        margin: -5px 0;
      }

      &:hover {
        background: #E0E4EC;
      }
    }
    
    .negativeMsg {
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #C94D4D;
      width: fit-content;
      margin-top: 20px;
      padding: 10px 20px;
      border-radius: 3px;
      line-height: 25px;
      background: #F9E9E9;
    }

    .positiveMsg {
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #295238;
      width: fit-content;
      margin-top: 20px;
      padding: 10px 20px;
      border-radius: 3px;
      line-height: 25px;
      background: #DCEADC;
    }
  }
`;





const Wrap = styled.div`

`;

export const wrapRootElement = ({ element }) => (
  <CookiesProvider>
    <Wrap>
      <GlobalStyles />
      {element}      
    </Wrap>
  </CookiesProvider>
);
